const WalletReport = () =>
  import(/* webpackChunkName: "Wallet" */ '@/pages/financial/wallet/index.vue')

export default {
  name: 'Wallet',
  path: 'wallet',
  meta: { label: 'wallet' },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'Wallet',
      path: '',
      meta: { label: 'wallet' },
      component: WalletReport
    }
  ]
}
